import { createFileRoute } from '@tanstack/react-router'
import { Helmet } from 'react-helmet-async'
import { FoundingMember } from '@/components/landing/FoundingMember'

export const Route = createFileRoute('/founding-member')({
  component: FoundingMemberPage,
})

function FoundingMemberPage() {
  return (
    <>
      <Helmet>
        <title>Founding Member — Genie</title>
        <meta
          name="description"
          content="Join the first 10,000 creators. $1,000 gets you lifetime platform access, $1,000 in credits, and 15% referral earnings."
        />
        <meta property="og:title" content="Become a Founding Member — Genie" />
        <meta
          property="og:description"
          content="Lifetime platform access. $1,000 in credits. 15% referral earnings. First 10,000 only."
        />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Genie" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Become a Founding Member — Genie" />
        <meta
          name="twitter:description"
          content="Lifetime platform access. $1,000 in credits. 15% referral earnings. First 10,000 only."
        />
      </Helmet>
      <FoundingMember />
    </>
  )
}
